export enum IssueStatusEnum {
    New = 0,
    Approve = 1,
    Reject = 2
}

export enum IssueTypeEnum {
  Admin = 0,
  Public = 1
}


